export class Treatment {
    id: number = 0;
    name: string = '';
    ignoreTool: boolean = false;
    wellTolerated?: 'NoAE' | 'Grade1AE' | 'Grade2AE' | 'Grade3AE' | 'Grade4AE' = undefined;
    wasEffective?: 'PD' | 'SD' | 'PR' | 'CR' = undefined;

    constructor(
        id: number,
        name: string,
        ignoreTool: boolean = false
    ) {
        this.id = id;
        this.name = name;
        this.ignoreTool = ignoreTool;
    }
}
